// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuetify from 'vuetify'
import VueI18n from 'vue-i18n'
import 'vuetify/dist/vuetify.css'

import App from './App'
import router from '@router/router'
import store from '@store'

import VueAnalytics from 'vue-analytics'

import messages from './i18n'
import VueWorker from 'vue-worker'
Vue.use(VueWorker)

Vue.prototype.$subdomainPartner = 'default'

if (window.location.host.includes('smartchoice')) {
  Vue.prototype.$subdomainPartner = '5a4fa82c8e4b74e028665d04'
} else if (window.location.host.includes('grayhawk')) {
  Vue.prototype.$subdomainPartner = '5acb94000495d7065c909bc2'
} else if (window.location.host.includes('imaginemd')) {
  Vue.prototype.$subdomainPartner = '5b73507c4aef2028740f662b'
} else if (window.location.host.includes('newparkmedical')) {
  Vue.prototype.$subdomainPartner = '5a3f56ec92808ba8d3d5a391'
} else {
  Vue.prototype.$subdomainPartner = 'default'
}

Vue.use(Vuetify, {
  theme: {
    primary: '#4485ed',
    secondary: '#5F5F5F',
    accent: '#43A047',
    deselected: '#cccccc',
    scgreen: '#8AC33E',
    contrast: '#BDBDBD',
    headerColor: '#ffffff'
  }
})

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages
})

Vue.prototype.$default = {
  avatar: {
    sm: 47,
    lg: 74,
    xl: 120
  }
}

// Config
Vue.config.productionTip = process.env.NODE_ENV !== 'production'

// const isProd = process.env.NODE_ENV === 'production'

Vue.use(VueAnalytics, {
  id: 'UA-124830022-1',
  router,
  autoTracking: {
    exception: true
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js